import { CreateDoctorPayload } from "@/domain/repository/doctor-repository";
import {
  CreateDoctorValidationError,
  CreateMedicalExpertUsecase,
  normalizeCreateDoctorPayload,
} from "@/domain/usecase/doctor/create-medical-expert-usecase";
import { SATError, SATResult } from "@sadtx/sat-error";

export class CreateNurseUsecase extends CreateMedicalExpertUsecase {
  async execute(payload: CreateDoctorPayload): Promise<SATResult<void, SATError>> {
    const validationErrors = this.validate(payload);
    if (Object.keys(validationErrors).length > 0) {
      return SATResult.failure(new CreateDoctorValidationError(validationErrors));
    }

    return this.doctorRepo.createNurse(normalizeCreateDoctorPayload(payload));
  }
}
